/* eslint-disable id-blacklist */
import React from 'react';
// eslint-disable-next-line no-restricted-imports
import { Dropdown } from 'reactstrap';

import PropTypes from 'prop-types';

const DropdownWrapper = ({ children, onClick, className, id, ...props }) => (
  <Dropdown onClick={onClick} className={className} id={id} {...props}>
    {children}
  </Dropdown>
);

DropdownWrapper.propTypes = {
  children: PropTypes.node,
  onClick: PropTypes.func,
  className: PropTypes.string,
  id: PropTypes.string
};

DropdownWrapper.defaultProps = {
  children: undefined,
  onClick: undefined,
  className: undefined,
  id: undefined
};

export default DropdownWrapper;
